interface Validations {
  [key: string]: string | number | boolean | RegExp;
}

interface ValidationErrors {
  [key: string]: string;
}

interface ValidationRules {
  validations: Validations;
  validationErrors: ValidationErrors;
}

interface Rules {
  characterMax?: number | null;
  characterMin?: number | null;
  format?: string;
  regex?: string | null;
}
export const generateTextValidation = (rules: Rules): ValidationRules => {
  const { characterMax, characterMin, format = '', regex } = rules;

  const formatLow = format.toLowerCase();
  const validations: Validations = {};
  const validationErrors: ValidationErrors = {};
  if (characterMax) {
    validations.maxLength = characterMax;
    validationErrors.maxLength = `Max character length is ${characterMax}`;
  }
  if (characterMin) {
    validations.minLength = characterMin;
    validationErrors.minLength = `Min character length is ${characterMin}`;
  }
  if (formatLow === 'email') {
    validations.matchRegexp = /^[a-zA-Z0-9.+!#$%&amp;'^_`{}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    validationErrors.matchRegexp = 'This is not a valid email';
  }
  if (formatLow === 'url') {
    validations.isUrl = true;
    validationErrors.isUrl = 'This is not a valid URL';
  }
  if (formatLow === 'phone') {
    validations.matchRegexp = /^\+?(\d\s*){9,12}$/;
    validationErrors.matchRegexp = 'This is not a valid phone number';
  }
  if (regex) {
    validations.matchRegexp = new RegExp(regex);
    validationErrors.matchRegexp = 'The format is incorrect';
  }
  // TODO: hscode, phone, company register number
  return { validations, validationErrors };
};
